import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { BillableIcon, Tag, Tags, Tooltip } from '~/components';
import { colors, weights } from '~/styles';

const Styled = {
  AssignedTo: styled.div`
    color: ${colors.grey40};
    font-size: 0.75rem;
    font-weight: ${weights.black};
    letter-spacing: 0.0625rem;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
    margin-left: 0.25rem;
  `,

  ExpandCollapse: styled.div`
    margin-right: 0.75rem;
    color: ${colors.grey40};

    &:hover {
      cursor: pointer;
      color: ${colors.grey75};
    }
  `,
};

function FirstAssignment({ task, project }) {
  // Find the first active project role
  const taskRole = task.roles.find((v) => v.role.isActive);
  if (project.useRoles && taskRole) {
    return (
      <Tag style={{ backgroundColor: colors.grey5 }}>
        <BillableIcon value={taskRole.role.isActuallyBillable} />
        <small>{taskRole.role.name}</small>
      </Tag>
    );
  } else {
    // Find the first active project member
    const taskMember = task.members.find((v) => v.projectMember.isActive && v.projectMember.member.isActive);
    if (!taskMember) {
      return null;
    }
    return (
      <Tag style={{ backgroundColor: colors.primary10 }} data-testid="first_member">
        <small>{taskMember.projectMember.member.name}</small>
      </Tag>
    );
  }
}

export default function Assignments({ task, project }) {
  let assignmentsCount = -1; // Remove the first assignment because it already shows a tag
  // Filter active project members
  const activeMembers = _.filter(task?.members, (v) => v.projectMember.isActive && v.projectMember.member.isActive);
  // Filter active project roles
  const activeRoles = _.filter(task?.roles, (v) => v.role.isActive);
  assignmentsCount += activeMembers.length; // Add members
  if (project.useRoles) assignmentsCount += activeRoles.length; // Add roles if the project uses roles

  return (
    <Tags>
      <FirstAssignment task={task} project={project} />

      {assignmentsCount > 0 && (
        <Tooltip
          data-testid="assignment_tooltip"
          style={{ display: 'flex' }}
          message={
            <div data-testid="assignment_popper" style={{ fontSize: '1rem' }}>
              <Styled.AssignedTo>Assigned to</Styled.AssignedTo>
              {activeMembers.map(({ projectMember: { member } }) => (
                <Tag style={{ backgroundColor: colors.primary10 }} key={member.id}>
                  <small>{member.name}</small>
                </Tag>
              ))}
              {project.useRoles &&
                activeRoles.map(({ role }) => (
                  <Tag style={{ backgroundColor: colors.grey5 }} key={role.id}>
                    <BillableIcon value={role.isActuallyBillable} />
                    <small>{role.name}</small>
                  </Tag>
                ))}
            </div>
          }>
          <Tag style={{ backgroundColor: colors.grey5, color: colors.grey40 }}>
            <small>+{assignmentsCount}</small>
          </Tag>
        </Tooltip>
      )}
    </Tags>
  );
}
